// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yMntYuzO4M4BkF31SZB3{display:flex;position:relative}.J2LXszUjLycsK141mHJA{border-top-left-radius:6px;border-bottom-left-radius:6px}.YHpjndDVUbcxek6GpDBl{border-top-right-radius:6px;border-bottom-right-radius:6px;width:24px}.YHpjndDVUbcxek6GpDBl.DhVJdOFbYPAuSL86qW42:before{background:var(--white-50)}.YHpjndDVUbcxek6GpDBl.q0d1QQewBIc4AwToSYbd:before{background:0 0}.YHpjndDVUbcxek6GpDBl:before{content:"";background:var(--border-neutral-primary);width:1px;height:16px;position:absolute;left:0}.gMVPcnI_4Dooarj_sr69{z-index:var(--zIndex-BASE_20)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `yMntYuzO4M4BkF31SZB3`,
	"leftBtn": `J2LXszUjLycsK141mHJA`,
	"rightBtn": `YHpjndDVUbcxek6GpDBl`,
	"primary": `DhVJdOFbYPAuSL86qW42`,
	"loading": `q0d1QQewBIc4AwToSYbd`,
	"confirmationBtnWrap": `gMVPcnI_4Dooarj_sr69`
};
export default ___CSS_LOADER_EXPORT___;
